module.exports = __webpack_public_path__ + "static/media/left-arrow.77c86913.svg";